<template>
  <div class="full-height">
    <q-card class="full-width full-height">
      <q-card-actions class="bg-accent text-white q-pa-md">
        <div class="title">
          {{
            formData.hasOwnProperty("basicGoalAction") &&
            formData.basicGoalAction
              ? formData.basicGoalAction
              : "Pre-written Goal"
          }}
        </div>
        <q-space></q-space>
        <!-- <q-btn
          color="primary"
          style="width: 100px"
          class="q-mr-sm sustainability-button"
          @click="save"
        >
          Save
        </q-btn> -->
        <!-- <q-btn
          :loading="isLoading"
          style="width: 100px; background-color: #6dbf50"
          class="q-mr-sm sustainability-button"
          @click="save(false, true)"
        >
          Save & Add New
        </q-btn> -->
        <q-btn
          color="primary"
          style="width: 100px"
          :loading="saveLoading"
          class="q-mr-sm sustainability-button"
          @click="save(true, false)"
        >
          Save & Close
        </q-btn>

        <q-btn @click="closeDialog" flat icon="mdi-close" size="5" round />
      </q-card-actions>
      <q-card-section class="q-pa-none">
        <q-tabs v-model="tab" align="left">
          <q-tab v-for="(tabItem, i) in tabs" :key="i" :name="tabItem.name">
            <div style="display: inline">
              <span class="tabTitle">{{ tabItem.label }} </span>
              <q-icon
                name="mdi-alert-circle"
                color="red"
                v-if="tabItem.isError"
              >
              </q-icon>
            </div>
          </q-tab>
        </q-tabs>

        <q-tab-panels v-model="tab" animated keep-alive ref="tabs">
          <!---GENERAL-->
          <q-tab-panel name="general">
            <div class="row q-mb-sm items-center q-mt-none">
              <div class="col-12">
                <div class="title q-my-none q-mt-lg">Pre-written Goal</div>
              </div>
            </div>
            <div class="row">
              <span class="text-grey" style="max-width: 600px">
                This is the image used as the stock image default for
                Pre-written Goals.
              </span>
            </div>
            <q-form ref="form">
              <div class="row q-my-sm">
                <!-- IMG Section -->
                <div class="col-auto q-pa-sm">
                  <div
                    v-if="
                      (changeImage || !formData.basicGoalImageUrl) &&
                      formData.id
                    "
                  >
                    <div style="width: 300px">
                      <croppa
                        ref="imgCroppa"
                        :height="200"
                        :width="300"
                        v-model="myCroppa"
                        remove-button-color="#68c6d2"
                        :show-loading="true"
                        :loading-size="50"
                        crossOrigin="anonymous"
                        :quality="2"
                        :prevent-white-space="false"
                      ></croppa>
                    </div>
                    <div class="row" style="width: 300px">
                      <span class="text-caption">
                        (this is the image used as the default when a user
                        selects this goal from Upstream's list )
                      </span>
                    </div>
                    <div class="row" style="width: 300px">
                      <span class="text-caption"
                        >Recommended .jpg/.jpeg files and ideally 500Kb
                      </span>
                    </div>
                  </div>

                  <div v-else style="margin: auto; width: 300px">
                    <q-img
                      :src="formData.basicGoalImageUrl"
                      style="width: 300px; height: 200px"
                      v-if="formData.id"
                    >
                    </q-img>
                    <q-btn
                      class="full-width"
                      color="primary"
                      label="Change"
                      @click="changeImage = true"
                      v-if="formData.id"
                    >
                    </q-btn>

                    <div class="row">
                      <span class="text-caption">
                        (this is the image used as the default when a user
                        selects this goal from Upstream's list )
                      </span>
                    </div>
                    <div class="row">
                      <span class="text-caption"
                        >Recommended .jpg/.jpeg files and ideally 500Kb
                      </span>
                    </div>
                  </div>
                </div>
                <!-- Info Box Section -->
                <div class="col q-pa-sm">
                  <div class="row">
                    <div class="col-8 q-px-xs">
                      <q-input
                        label="Pre-Written Goal Entry"
                        v-model="formData.basicGoalAction"
                        hint="Pre-Written Goal Entry
                  Please written the full sentence of the
                pre-written goal you want as a selectable option"
                        :rules="[(v) => !!v || 'Field is Required']"
                      >
                      </q-input>
                    </div>

                    <div class="col-4 q-px-xs">
                      <q-input
                        label="Coloured Text"
                        v-model="formData.basicGoal"
                        hint="Please copy and match the word in
                      the sentence of your Pre-Written Goal,
                    to what word will be changed to a special colour"
                        :rules="[(v) => !!v || 'Field is Required']"
                      ></q-input>
                    </div>
                    <div class="col-12 q-px-xs q-my-md">
                      <div class="row">
                        <span class="text-grey"> Text Preview </span>
                      </div>
                      <div class="row" v-if="formData.basicGoalAction">
                        <div
                          v-for="(text, i) in formData.basicGoalAction.split(
                            ' '
                          )"
                          :key="i"
                          class="previewGoalText"
                          :class="`${i > 0 ? 'q-ml-xs' : ''} ${
                            isTextColored(text, formData.basicGoal)
                              ? 'text-primary'
                              : ''
                          }`"
                        >
                          {{ text }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </q-form>
          </q-tab-panel>
          <!---OUTCOMES-->
          <q-tab-panel name="outcomes">
            <div class="row q-mb-sm items-center">
              <div class="col-9">
                <div class="row items-center q-col-gutter-x-md">
                  <div class="title q-my-none q-mx-none">Outcomes</div>

                  <div style="width: 200px">
                    <q-form ref="outcomeForm">
                      <q-select
                        :options="filteredOutcomesList"
                        v-model="selectedOutcome"
                        label="Outcome"
                        map-options
                        emit-value
                        option-value="id"
                        option-label="name"
                      >
                      </q-select>
                    </q-form>
                  </div>
                  <div>
                    <q-btn
                      :disabled="!selectedOutcome"
                      color="primary"
                      @click="addOutcome"
                    >
                      <q-icon name="mdi-plus-circle"> </q-icon>
                      <span class="sustainability-font q-mx-sm"> Add </span>
                    </q-btn>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <q-input
                  class="searchbar float-right"
                  style="max-width: 70%"
                  filled
                  v-model="searchText"
                  debounce="200"
                  label="Search"
                  clearable
                  dense
                >
                  <template #prepend>
                    <q-icon name="mdi-magnify"></q-icon>
                  </template>
                </q-input>
              </div>
            </div>

            <data-table
              style="height: calc(100vh - 270px)"
              headerBgColor="#162c47"
              headerTextColor="white"
              :columns="columns"
              :data="data.outcomes"
              flat
              :filter="searchText"
            >
              <template slot="body-cell-rank" slot-scope="data">
                <q-td :props="data.props">
                  <q-input
                    style="max-width: 80px"
                    dense
                    color="accent"
                    @blur="saveOutcome(data.props.row)"
                    label=""
                    v-model="data.props.row.rank"
                  >
                    <template v-slot:no-option>
                      <q-item>
                        <q-item-section class="text-grey">
                          No results
                        </q-item-section>
                      </q-item>
                    </template>
                  </q-input>
                </q-td>
              </template>
              <template slot="body-cell-actions" slot-scope="data">
                <q-td :props="data.props">
                  <q-btn
                    round
                    color="red"
                    flat
                    icon="mdi-delete"
                    @click="removeOutcome(data.props.row)"
                    size="md"
                    class="float-right"
                  >
                    <q-tooltip content-class="bg-accent" :offset="[10, 10]">
                      Remove Outcome
                    </q-tooltip>
                  </q-btn>
                </q-td>
              </template>
            </data-table>
          </q-tab-panel>
          <!--SOLUTIONS-->
          <q-tab-panel name="solutions">
            <div class="row q-mb-sm items-center">
              <div class="col-9">
                <div class="row items-center q-col-gutter-x-md">
                  <div class="title q-my-none q-mx-none">Solutions</div>

                  <div style="width: 200px">
                    <q-form ref="solutionForm">
                      <Autocomplete
                        :items="filteredSolutionsList"
                        :id="selectedSolution"
                        @changed="(val) => (selectedSolution = val)"
                        v-model="selectedSolution"
                        label="Solutions"
                        option_value="id"
                        option_label="title"
                        :loading="solutionsListLoading"
                      >
                      </Autocomplete>
                    </q-form>
                  </div>
                  <div>
                    <q-btn
                      :disabled="!selectedSolution"
                      color="primary"
                      @click="addSolution"
                    >
                      <q-icon name="mdi-plus-circle"> </q-icon>
                      <span class="sustainability-font q-mx-sm"> Add </span>
                    </q-btn>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <q-input
                  class="searchbar float-right"
                  style="max-width: 70%"
                  filled
                  v-model="searchText"
                  debounce="200"
                  label="Search"
                  clearable
                  dense
                >
                  <template #prepend>
                    <q-icon name="mdi-magnify"></q-icon>
                  </template>
                </q-input>
              </div>
            </div>

            <data-table
              style="height: calc(100vh - 270px)"
              headerBgColor="#162c47"
              headerTextColor="white"
              :columns="solutionsColumns"
              :data="data.solutions"
              flat
              :filter="searchText"
            >
              <template slot="body-cell-rank" slot-scope="data">
                <q-td :props="data.props">
                  <q-input
                    style="max-width: 80px"
                    dense
                    color="accent"
                    @blur="saveSolution(data.props.row)"
                    label=""
                    v-model="data.props.row.rank"
                  >
                    <template v-slot:no-option>
                      <q-item>
                        <q-item-section class="text-grey">
                          No results
                        </q-item-section>
                      </q-item>
                    </template>
                  </q-input>
                </q-td>
              </template>
              <template slot="body-cell-actions" slot-scope="data">
                <q-td :props="data.props">
                  <q-btn
                    round
                    color="red"
                    flat
                    icon="mdi-delete"
                    @click="removeSolution(data.props.row)"
                    size="md"
                    class="float-right"
                  >
                    <q-tooltip content-class="bg-accent" :offset="[10, 10]">
                      Remove Solution
                    </q-tooltip>
                  </q-btn>
                </q-td>
              </template>
            </data-table>
          </q-tab-panel>
        </q-tab-panels>
      </q-card-section>
    </q-card>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import DataTable from "@/components/datatable/datatable.vue";
  import moment from "moment";
  import Autocomplete from "@/components/autocomplete/autocomplete.vue";

  export default {
    props: {
      newBasicGoal: {
        type: Boolean,
        default: false,
      },
      section_id: {
        type: Number,
        default: null,
      },
    },
    components: {
      DataTable,
      Autocomplete,
    },
    computed: {
      ...mapGetters({
        data: "basicGoals/current",
        dataLoading: "basicGoals/currentLoading",
        outcomesList: "outcomes/list",
        outcomesListLoading: "outcomes/listLoading",
        solutionsList: "solutions/list",
        solutionsListLoading: "solutions/listLoading",
      }),
      filteredOutcomesList() {
        return this.outcomesList.filter((e) => {
          if (this.data.outcomes.findIndex((o) => e.id == o.outcomes_id) < 0) {
            return e;
          }
        });
      },
      filteredSolutionsList() {
        // console.log(this.solutionsList);
        return this.solutionsList.filter((e) => {
          if (this.data.solutions.findIndex((s) => e.id == s.solution_id) < 0) {
            return e;
          }
        });
      },
      //outcomes table
      columns() {
        return [
          {
            name: "id",
            label: "ID",
            align: "left",
            field: "id",
            style:
              "min-width: 90px;max-width: 90px;width: 90px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "outcomeName",
            label: "Outcome Name",
            align: "left",
            field: "name",
            style:
              "min-width: 300px;max-width: 300px;width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "rank",
            label: "Rank",
            align: "left",
            field: "rank",
            style:
              "min-width: 300px;max-width: 300px;width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "actions",
            label: "Actions",
            align: "right",
            field: "delete",
            style:
              "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          },
        ];
      },
      //solutions table
      solutionsColumns() {
        return [
          {
            name: "id",
            label: "ID",
            align: "left",
            field: "id",
            style:
              "min-width: 90px;max-width: 90px;width: 90px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "title",
            label: "Title",
            align: "left",
            field: "title",
            style:
              "min-width: 500px;max-width: 300px;width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          },
          {
            name: "rank",
            label: "Rank",
            align: "left",
            field: "rank",
            style:
              "min-width: 300px;max-width: 300px;width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "actions",
            label: "Actions",
            align: "right",
            field: "delete",
            style:
              "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          },
        ];
      },
    },

    watch: {
      $route: function () {
        this.handleRoute();
      },
      data: {
        deep: true,
        handler() {
          this.init();
        },
      },
    },
    data: () => ({
      //tab
      tab: "general",
      tabs: [
        {
          name: "general",
          label: "Pre-written Goal",
          isError: false,
        },
        {
          name: "outcomes",
          label: "Outcomes",
          isError: false,
        },
        {
          name: "solutions",
          label: "Solutions",
          isError: false,
        },
      ],

      //table
      searchText: "",

      // basicGoal Form Data
      formData: {
        status: "draft",
      },

      //status options
      status: ["draft", "live"],

      //outcomeForm
      selectedOutcome: "",

      saveLoading: false,

      //solutionForm
      selectedSolution: "",

      //croppa
      myCroppa: {},
      changeImage: false,
    }),
    async mounted() {
      this.loadData();
      this.handleRoute();
      this.init();
    },
    methods: {
      // GENERAL
      loadData() {
        console.log(1);
        this.$store.dispatch(
          "basicGoals/loadByID",
          this.$route.params.basicGoal_id
        );

        this.$store.dispatch("solutions/loadAll");
      },
      init() {
        if (this.data != null) {
          this.formData = JSON.parse(JSON.stringify(this.data));
          if (this.formData.status == "temp") {
            this.formData.status = "live";
          }
        }
      },
      isTextColored(currentText, TextToBeColored) {
        if (TextToBeColored) {
          let textToBeColoredArray = TextToBeColored.split(" ");
          if (textToBeColoredArray.includes(currentText)) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      },
      closeDialog() {
        this.$router.push("/preWrittenGoals");
      },
      async handleRoute() {
        if (this.$route.params.hasOwnProperty("referenceID")) {
          this.isAddingReference = true;
          this.$refs.tabs.goTo("reference");
        }
      },

      // BASIC GOAL
      async save(isClose, isAddNew) {
        //source validation
        const isValid = await this.$refs.form.validate();

        if (isValid) {
          this.saveLoading = true;
          let payload = { ...this.formData };
          //image uploading
          if (this.myCroppa && this.myCroppa.imageSet) {
            payload.basicGoalImage = {
              dataUrl: this.myCroppa.generateDataUrl(),
            };
          } else {
            delete payload.imageUrl;
          }

          try {
            let result = await this.$store.dispatch("basicGoals/save", payload);
            if (result.Result == "Success") {
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message,
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          } catch (error) {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }

          this.saveLoading = false;

          if (isClose) {
            this.closeDialog();
          }
        }
      },

      // OUTCOME
      async addOutcome() {
        const isValid = await this.$refs.outcomeForm.validate();
        if (isValid) {
          let outcomesSourcesPayload = {
            outcomes_id: this.selectedOutcome,
            basicGoals_id: this.data.id,
          };
          let result = await this.$store.dispatch(
            "basicGoals/addOutcome",
            outcomesSourcesPayload
          );
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });
            this.selectedOutcome = "";
            this.$refs.outcomeForm.reset();
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        }
      },
      async saveOutcome(payload) {
        try {
          let result = await this.$store.dispatch(
            "basicGoals/saveOutcome",
            payload
          );
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        } catch (error) {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later",
          });
        }
      },
      async removeOutcome(outcome) {
        this.$swal({
          title: "Warning",
          text: "You are about to remove this outcome from the Basic Goal, Are you sure you want to continue?",
          type: "warning",
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          showCancelButton: true,
          confirmButtonColor: "#f58122",
        }).then(async (res) => {
          if (res.value) {
            let removedOutcome = {
              id: outcome.id,
              basicGoals_id: outcome.basicGoals_id,
              deleted_at: moment().format("YYYY-MM-DD hh:mm:ss"),
            };
            let result = await this.$store.dispatch(
              "basicGoals/saveOutcome",
              removedOutcome
            );
            if (result.Result == "Success") {
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message,
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          }
        });
      },

      // SOLUTION
      async addSolution() {
        const isValid = await this.$refs.solutionForm.validate();
        if (isValid) {
          let solutionsSourcesPayload = {
            solution_id: this.selectedSolution,
            basicGoals_id: this.data.id,
          };
          let result = await this.$store.dispatch(
            "basicGoals/addSolution",
            solutionsSourcesPayload
          );
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });
            this.selectedSolution = "";
            this.$refs.solutionForm.reset();
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        }
      },
      async saveSolution(payload) {
        try {
          let result = await this.$store.dispatch(
            "basicGoals/saveSolution",
            payload
          );
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        } catch (error) {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later",
          });
        }
      },
      async removeSolution(solution) {
        this.$swal({
          title: "Warning",
          text: "You are about to remove this solution from the Basic Goal, Are you sure you want to continue?",
          type: "warning",
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          showCancelButton: true,
          confirmButtonColor: "#f58122",
        }).then(async (res) => {
          if (res.value) {
            let removedSolution = {
              id: solution.id,
              basicGoals_id: solution.basicGoals_id,
              deleted_at: moment().format("YYYY-MM-DD hh:mm:ss"),
            };
            let result = await this.$store.dispatch(
              "basicGoals/saveSolution",
              removedSolution
            );
            if (result.Result == "Success") {
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: "Solution was removed",
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          }
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .title {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 13px;
  }

  .sustainability-button {
    min-width: 151px;
    height: 34px;
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 600;
    font-size: 9px;
    line-height: 11px;
    display: flex;
    align-items: center;
    text-align: center;
  }

  .previewGoalText {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
  }

  .tabTitle {
    font-weight: bold;
  }

  .searchbar {
    @media (max-width: 479px) {
      max-width: 115px !important;
    }
  }
</style>
